const checkError = async (response) => {
  const json = await response.json()
  if (!response.ok) {
    const { message } = json
    const err = new Error(message)
    throw (err)
  }
  return json
}

export const getRequest = async (url) => {
  const response = await fetch(`${process.env.REACT_APP_SERVICE_URI}${url}`)
  const json = await checkError(response)
  return json
}

export const postRequest = async (url, body = {}) => {
  const response = await fetch(`${process.env.REACT_APP_SERVICE_URI}${url}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const json = await checkError(response)
  return json
}

export default {
  get: getRequest,
  post: postRequest,
}



// WEBPACK FOOTER //
// ./src/services/requests.js